export default __webpack_public_path__ + "static/media/Salmon Bagel _proportioned_170.7e96e77f.jpg";